import { render } from "./com.vue?vue&type=template&id=6e54182c"
import script from "./com.vue?vue&type=script&lang=js"
export * from "./com.vue?vue&type=script&lang=js"

import "./com.vue?vue&type=style&index=0&id=6e54182c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/gotoTop/com.vue'],['render',render],['__file',"com.vue"]])

export default __exports__